export const knowledgeStatus = {
  uploaded: { label: "Aguardando processamento", color: "default", progress: 5 },
  queued: { label: "Na fila", color: "default", progress: 10 },
  processing: { label: "Processando", color: "primary", progress: 50 },
  ready_for_approval: { label: "Pronto para aprovação", color: "secondary", progress: 100 },
  approved: { label: "Em uso", color: "primary", progress: 100 },
  active: { label: "Em uso", color: "primary", progress: 100 },
  error: { label: "Erro", color: "secondary", progress: 0 },
  failed: { label: "Falhou", color: "secondary", progress: 0 },
  completed: { label: "Processada, aguardando aprovação", color: "secondary", progress: 100 },
  canceled: { label: "Cancelada", color: "default", progress: 0 },
  superseded: { label: "Substituída", color: "default", progress: 100 },
  retired: { label: "Retirada de uso", color: "default", progress: 0 },
  deleting: { label: "Exclusão agendada", color: "default", progress: 0 },
  deleted: { label: "Excluída", color: "default", progress: 0 },
  draft: { label: "Rascunho", color: "default", progress: 0 },
};

export const DEFAULT_KNOWLEDGE_LIMITS = {
  maxFileBytes: 10 * 1024 * 1024,
  maxTextCharacters: 250000,
  maxFaqItems: 100,
  maxSourcesPerCompany: 100,
  maxStorageBytesPerCompany: 50 * 1024 * 1024,
};

export const statusInfo = (status, progress) => ({
  ...(knowledgeStatus[status] || { label: status || "Desconhecido", color: "default", progress: 0 }),
  progress: Number.isFinite(Number(progress)) ? Number(progress) : (knowledgeStatus[status]?.progress || 0),
});

export const formatKnowledgeBytes = (value) => {
  const bytes = Number(value || 0);
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const credentialsForEmbeddingProfile = (credentials, profile) =>
  (credentials || []).filter(
    (credential) =>
      credential.status === "active" &&
      credential.purpose === "embedding" &&
      credential.provider === profile?.model?.provider
  );

export const faqTextToItems = (value) =>
  String(value || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const separator = line.indexOf("|");
      if (separator < 1) return { question: line, answer: "" };
      return {
        question: line.slice(0, separator).trim(),
        answer: line.slice(separator + 1).trim(),
      };
    });

export const validateKnowledgeSourceDraft = (form, limits = DEFAULT_KNOWLEDGE_LIMITS) => {
  const effective = { ...DEFAULT_KNOWLEDGE_LIMITS, ...(limits || {}) };
  if (form.type === "url") {
    try {
      const pageUrl = new URL(String(form.url || "").trim());
      if (pageUrl.protocol !== "https:" || pageUrl.port || pageUrl.username || pageUrl.password || pageUrl.href.length > 2048) {
        return "Informe uma URL HTTPS pública válida, sem porta ou credenciais.";
      }
    } catch {
      return "Informe uma URL HTTPS pública válida.";
    }
  }
  if (["pdf", "txt", "markdown"].includes(form.type) && form.file?.size > effective.maxFileBytes) {
    return `O arquivo excede o limite de ${formatKnowledgeBytes(effective.maxFileBytes)}.`;
  }
  if (form.type === "text" && String(form.text || "").length > effective.maxTextCharacters) {
    return `O texto excede o limite de ${effective.maxTextCharacters.toLocaleString("pt-BR")} caracteres.`;
  }
  if (form.type === "faq") {
    const items = faqTextToItems(form.faqText);
    if (items.length > effective.maxFaqItems) {
      return `Informe no máximo ${effective.maxFaqItems} perguntas e respostas.`;
    }
    if (items.some((item) => !item.question || !item.answer || item.question.length > 500 || item.answer.length > 5000)) {
      return "Cada linha deve ter pergunta de até 500 caracteres e resposta de até 5.000 caracteres.";
    }
  }
  return null;
};

export const buildKnowledgeSourceFormData = ({ type, name, text, url, faqText, file }) => {
  const form = new FormData();
  form.append("type", type);
  form.append("name", name);
  if (["pdf", "txt", "markdown"].includes(type) && file) form.append("file", file);
  if (type === "text") form.append("text", text || "");
  if (type === "url") form.append("url", String(url || "").trim());
  if (type === "faq") form.append("faqItems", JSON.stringify(faqTextToItems(faqText)));
  return form;
};
